import { forwardRef, InputHTMLAttributes } from 'react';
import s from '../index.module.scss';

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, IProps>(({ label, ...rest }, ref) => {
  return (
    <label className={`${s.checkbox} ${rest.disabled && s.disabled}`}>
      <input type="checkbox" ref={ref} {...rest} />
      <span className={s.checkmark}></span>
      {label && label}
    </label>
  );
});
